// ScanUploadModal.tsx (UI-only)
import React from 'react'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Flex, Spin, Upload } from 'antd'
import { calculateAge } from 'utils/Dob'
import { useScanUploadModal } from './useScanUploadModel'
import uploadSvg from '../../../../images/upload.svg'
import { SHADOWS } from '../../../../tokens'
import { Container, NameWrapper, Span, UploadContainer } from '../../HomeScreen/index.styled'

type CurrentScanUpload = {
  patientId: string | null
  visitId: string | null
  clinicId: string | null
  profilePic: string | null
  firstname: string | null
  lastname: string | null
  dob: string | null
}

export function ScanUploadModal({ patientInfo }: { patientInfo: CurrentScanUpload }) {
  const { todayScanStatus, fileUploaded, disableUpload, error, uploadProps, APIStatus } =
    useScanUploadModal(patientInfo)

  // ------------------------
  // Loading State
  // ------------------------
  if (todayScanStatus === APIStatus.pending) {
    return (
      <Container
        style={{
          height: '40%',
          width: '100%',
          background: '#10123d',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin />
      </Container>
    )
  }

  // ------------------------
  // Main UI
  // ------------------------
  return (
    <Container>
      <Flex style={{ padding: '30px', flexDirection: 'column' }}>
        <Flex gap={20}>
          <Avatar
            shape="square"
            style={{ borderRadius: 8, minWidth: '160px', minHeight: '160px' }}
            icon={patientInfo.profilePic ? <img src={patientInfo.profilePic ?? ''} /> : <UserOutlined />}
          />
          <Flex gap={20} style={{ flexDirection: 'column' }}>
            <NameWrapper>
              <Span style={{ textTransform: 'uppercase' }}>{patientInfo.firstname ?? '-'}</Span>
              <Span style={{ textTransform: 'uppercase' }}>{patientInfo.lastname ?? '-'}</Span>
            </NameWrapper>
            <Span>Age {calculateAge(patientInfo.dob)}</Span>
          </Flex>
        </Flex>

        <UploadContainer>
          <Upload.Dragger
            {...uploadProps}
            showUploadList={false}
            maxCount={1}
            accept=".pbi"
            style={{ border: 'none', backgroundColor: 'var(--color-bg)', boxShadow: SHADOWS.boxShadow }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Button
                children={error === '' ? (fileUploaded ? 'Scan Uploaded' : 'Upload Scan') : 'Upload Failed'}
                style={{
                  minWidth: '12.1rem',
                  paddingLeft: error === '' ? (fileUploaded ? '1.5rem' : '2.5rem') : '1.5rem',
                  height: '42px',
                  backgroundColor: error === '' ? (fileUploaded ? '#fffeff' : '#007f7c') : '#E33939',
                  backgroundImage: `url(${error === '' ? (fileUploaded ? 'none' : uploadSvg) : 'none'})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '15% center',
                  opacity: disableUpload && !fileUploaded ? 0.5 : 1,
                  color: error === '' ? (fileUploaded ? '#007f7c' : '#fffeff') : '#fffeff',
                }}
                disabled={disableUpload}
              />
            </div>
          </Upload.Dragger>
        </UploadContainer>
      </Flex>
    </Container>
  )
}
